import React from 'react';
import { Flag, Mail, MapPin } from 'lucide-react';
import { PAYPAL_URL } from '../utils/donate';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-slate-950 pt-16 pb-8 border-t-4 border-pac-red text-slate-300" data-id="element-86" data-mp="32nulgo2wc31d">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87" data-mp="32m1cv38q38qq">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-88" data-mp="36pzblcu4yhj9">
          <div className="col-span-1 md:col-span-2" data-id="element-89" data-mp="3uesa9h2573hk">
            <div className="flex items-center gap-2 mb-6" data-id="element-90" data-mp="3ucxs2ai99ph6">
              <Flag className="h-8 w-8 text-pac-gold" data-id="element-91" data-mp="37o2ul235f8m" />
              <div className="flex flex-col" data-id="element-92" data-mp="3lec9ifcsaage">
                <span className="font-serif font-bold text-2xl leading-tight text-white tracking-wide uppercase" data-id="element-93" data-mp="3ldkf37uxairp">
                  AZ City PAC
                </span>
                <span className="text-xs font-sans font-semibold text-pac-gold tracking-[0.2em] uppercase" data-id="element-94" data-mp="29ynnprb9nhh6">
                  Built Locally. Stronger Together.
                </span>
              </div>
            </div>
            <p className="text-slate-400 mb-6 max-w-md leading-relaxed" data-id="element-95" data-mp="3lalhzkmm4fwl">
              A statewide coalition protecting local decision-making and
              advancing policies that strengthen Arizona&apos;s cities and
              towns. Built locally. Stronger together.
            </p>
            <a href="/#join" className="inline-flex items-center gap-2 border-2 border-pac-gold text-pac-gold hover:bg-pac-gold hover:text-pac-navy px-5 py-2.5 rounded font-bold uppercase tracking-wider text-sm transition-colors" data-id="element-96" data-mp="3q8dih31bpace">
              Join the Coalition
            </a>
          </div>

          <div data-id="element-97" data-mp="hs1xx5e38gcv">
            <h2 className="text-white font-serif font-bold text-lg mb-6 uppercase tracking-wider" data-id="element-98" data-mp="huo5h50zavv3">
              Quick Links
            </h2>
            <ul className="space-y-3" data-id="element-99" data-mp="qsqeo7uv8utg">
              <li data-id="element-100" data-mp="qtrns6sbn78j">
                <a href="/#mission" className="hover:text-pac-gold transition-colors" data-id="element-101" data-mp="qr5fu61iqpps">
                  Our Mission
                </a>
              </li>
              <li data-id="element-102" data-mp="yu7h6qjrtnxo">
                <a href="/#commitments" className="hover:text-pac-gold transition-colors" data-id="element-103" data-mp="ytoa64vnsjyf">
                  Our Commitments
                </a>
              </li>
              <li data-id="element-104" data-mp="18l2ecpyk27xw">
                <a href="/#issues" className="hover:text-pac-gold transition-colors" data-id="element-105" data-mp="18lk6pbi3k20j">
                  Where Local Voices Matter
                </a>
              </li>
              <li data-id="element-106" data-mp="1hms5duoiz4v5">
                <a href="/#join" className="hover:text-pac-gold transition-colors" data-id="element-107" data-mp="1mjsao3djw3l7">
                  Join the Coalition
                </a>
              </li>
              <li data-id="element-108" data-mp="3obomle3mrfgi">
                <a href="/#leadership" className="hover:text-pac-gold transition-colors" data-id="element-109" data-mp="3oc6s71c6n613">
                  Board of Directors
                </a>
              </li>
              <li data-id="element-110" data-mp="2agomjdlikigf">
                <Link to="/news" className="hover:text-pac-gold transition-colors" data-id="element-111" data-mp="2ah858wiznavi">
                  News & Updates
                </Link>
              </li>
              <li data-id="element-112" data-mp="21kfmpxtmjhtr">
                <a href={PAYPAL_URL} target="_blank" rel="noopener noreferrer" className="text-pac-red font-bold hover:text-red-400 transition-colors" data-id="element-113" data-mp="1wnz1bbdt7hkd">
                  Contribute
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-114" data-mp="2kc01nx0u3rop">
            <h2 className="text-white font-serif font-bold text-lg mb-6 uppercase tracking-wider" data-id="element-115" data-mp="2kbgkwjmx79c9">
              Contact
            </h2>
            <ul className="space-y-4" data-id="element-116" data-mp="18xuxb2wplfsu">
              <li className="flex items-start gap-3" data-id="element-117" data-mp="18yxnf8m7je7p">
                <MapPin className="h-5 w-5 text-pac-gold shrink-0 mt-0.5" data-id="element-118" data-mp="13z1kzdt5ruu9" />
                <span data-id="element-119" data-mp="1414ieiwn4q90">
                  AZ City PAC
                  <br data-id="element-120" data-mp="2ruoitdpfuy2l" />
                  Arizona
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-121" data-mp="2wmppmk3u7wl8">
                <Mail className="h-5 w-5 text-pac-gold shrink-0" data-id="element-122" data-mp="2wok9dv3dhinq" />
                <span data-id="element-123" data-mp="2iwcg4dbas9ts">info@azcitypac.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col items-center text-center" data-id="element-124" data-mp="2nunvt4o9xejx">
          <div className="border-2 border-slate-700 p-4 mb-6 max-w-3xl w-full" data-id="element-125" data-mp="3bk8c1ft1lxpi">
            <p className="text-sm font-bold text-slate-400 uppercase tracking-wider" data-id="element-126" data-mp="3fkadbnuv8p49">
              Paid for by AZ City PAC. Not
              authorized by any candidate or candidate&apos;s committee.
            </p>
          </div>
          <p className="text-xs text-slate-500 max-w-3xl mb-4" data-id="element-127" data-mp="36mqeelkh74wt">
            Contributions to AZ City PAC are not
            deductible as charitable contributions for federal income tax
            purposes. Federal law requires us to use our best efforts to collect
            and report the name, mailing address, occupation, and name of
            employer of individuals whose contributions exceed $200 in a
            calendar year.
          </p>
          <p className="text-xs text-slate-600" data-id="element-128" data-mp="1wmvxmuyoc4gp">
            &copy; {new Date().getFullYear()} AZ City PAC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}